import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { getIconStyles as L } from "../styles.js";
const r = (e) => /* @__PURE__ */ C(
  "svg",
  {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: L(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_4324_14127)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.80465 0.0366413C1.17852 0.173969 0.620252 0.737009 0.487028 1.3655C0.435596 1.60816 0.437132 15.8926 0.488612 16.1393C0.59762 16.6617 1.04503 17.1821 1.55673 17.3818C1.87617 17.5065 1.89004 17.5073 3.53673 17.5073C5.31792 17.5073 5.23104 17.5175 5.4701 17.282C5.8607 16.8972 5.75416 16.2974 5.25273 16.0583L5.12073 15.9953L3.60064 15.9833L2.08053 15.9713L2.02264 15.904L1.96473 15.8367V8.74785V1.65904L2.03858 1.58519L2.11243 1.51135H9.20124H16.29L16.3574 1.56926L16.4247 1.62715L16.4367 3.14726L16.4487 4.66735L16.5117 4.79935C16.7508 5.30078 17.3506 5.40731 17.7353 5.01671C17.9709 4.77765 17.9607 4.86453 17.9607 3.08335C17.9607 1.43666 17.9598 1.42279 17.8352 1.10335C17.6862 0.721577 17.3553 0.363761 16.9799 0.178481C16.5867 -0.0156067 17.2739 -5.46623e-05 9.18873 0.00217734C3.19994 0.00383334 1.92722 0.00976134 1.80465 0.0366413ZM8.51673 6.50495C8.08137 6.55144 7.72572 6.73576 7.40474 7.08124C7.20259 7.29885 7.08093 7.51754 6.99856 7.81135L6.94473 8.00335L6.93794 15.0713C6.93338 19.7887 6.93933 22.2222 6.95582 22.3884C7.00293 22.8636 7.17777 23.2184 7.52424 23.542C7.73808 23.7417 8.0507 23.9088 8.31273 23.9635C8.56843 24.0168 22.8292 24.0171 23.0828 23.9638C23.608 23.8533 24.079 23.466 24.3113 22.9535C24.4626 22.6199 24.4528 23.1561 24.4523 15.2438C24.4518 7.18168 24.4676 7.86515 24.2736 7.47215C24.0062 6.93038 23.4806 6.56863 22.8668 6.50399C22.5929 6.47515 8.78719 6.47608 8.51673 6.50495ZM8.53888 8.0855L8.46873 8.15565V15.2513V22.347L8.53888 22.4172L8.60904 22.4873H15.701H22.793L22.8669 22.4135L22.9407 22.3396V15.2477V8.15565L22.8706 8.0855L22.8004 8.01535H15.7047H8.60904L8.53888 8.0855Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_4324_14127", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.452637 -0.000610352)"
        }
      ) }) })
    ]
  }
);
export {
  r as DuplicateIcon
};
//# sourceMappingURL=DuplicateIcon.js.map
